import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangaData';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50 whitespace-nowrap">
                韩漫星球
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              韩国漫画精选推荐平台，为你提供最优质的韩国漫画推荐、最全面的作品资讯和最专业的阅读指南。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/category/lianai" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-xs px-3 py-1.5 rounded-full bg-background-50/10 text-background-50/70 hover:bg-primary-500/20 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/70 hover:text-primary-400 hover:bg-primary-500/20 transition-colors cursor-pointer whitespace-nowrap" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/70 hover:text-primary-400 hover:bg-primary-500/20 transition-colors cursor-pointer whitespace-nowrap" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/70 hover:text-primary-400 hover:bg-primary-500/20 transition-colors cursor-pointer whitespace-nowrap" aria-label="邮箱" rel="nofollow">
                <i className="ri-mail-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/70 hover:text-primary-400 hover:bg-primary-500/20 transition-colors cursor-pointer whitespace-nowrap" aria-label="RSS" rel="nofollow">
                <i className="ri-rss-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; 2024 韩漫星球. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}